export default __webpack_public_path__ + "static/main-1cfa5ac95c2fe18e59f5df5a47c83c01.jpg";